import {moment} from 'helpers';
import {format} from './convert';

export function emotionsMeter(record) {
  return {
    ...record,
    date: record.date ? moment(record.date, format).unix() : undefined,
  }
}
